export const MAXIMUM_FILE_LIMIT_TEXT = 'You can only attach a maximum of 5 attachments.';
export const SELECT_AT_LEAST_ONE_ITEM_TEXT = 'Please select at least one item.';
